import { render, staticRenderFns } from "./Cleaners.vue?vue&type=template&id=b89e6f1a"
import script from "./Cleaners.vue?vue&type=script&lang=js"
export * from "./Cleaners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports